export const products = [
    {
      linkUrl: "/products/vista-iwa",
      imageUrl: "/images/dummy-img.jpg",
      cardTitle: "Vista IWA",
      cardContent:
        "Vista - IWA Dr. Vista 108 IWA is a unique multipurpose advanced technology Integral Waterproofing compound.Dr.Vista 108 IWA + is made from specially formulated cement friendly surface active agents, corrosion inhibit additive and polymers.It is used as an additive for cement concrete, mortar & plasters while constructing the building.The presence of this integral compound resists and reverses thenormal tendency of hardened concrete to absorb water by capillary action and makes the concrete totally sealed against penetration of water.",
    },

    {
      linkUrl: "/products/vista-no-2",
      imageUrl: "/images/dummy-img.jpg",
      cardTitle: "Vista No. 2",
      cardContent:
        "VISTA NO - 2 is an extra fast setting waterproof / plugging compound liquid.",
    },
    {
      linkUrl: "/products/vista-no-3",
      imageUrl: "/images/dummy-img.jpg",
      cardTitle: "Vista No. 3",
      cardContent:
        "A multipurpose quick setting for cement mortar & concrete additive in liquid form when added to concrete, results in quick setting or rapid hardening of the same.",
    },
    {
      linkUrl: "/products/vista-sbr-latex-plus",
      imageUrl: "/images/dummy-img.jpg",
      cardTitle: "Vista SBR Latex Plus",
      cardContent:
        "Dr. Vista SBR Latex Plus is a milky-white, styrene-butadiene co-polymer latex liquid, developed to improve the waterproofing, bonding, physical properties and integrity of cementitious mortars, screeds and concretes.It reduces the mixing time through high dispersion of the polymer. Dr. Vista SBR Latex Plus improves durability, compressive, tensile and flexural properties of modified mixes.It is suitable for horizontal or vertical applications, both internally and externally. Meets the requirements of BS 6319 part II:1983 & ASTM C 190-85 standards.",
    },
    {
      linkUrl: "/products/vista-super-crete",
      imageUrl: "/images/dummy-img.jpg",
      cardTitle: "Vista Super Crete",
      cardContent:
        "Polyurethane coatings are flexible and provide excellent waterproofing for a variety of surfaces, including roofs, balconies, and concrete structures. They are known for their durability and resistance to UV radiation.",
    },
    {
      linkUrl: "/products/vista-flex-seal-plus",
      imageUrl: "/images/dummy-img.jpg",
      cardTitle: "Vista Flex Seal +",
      cardContent:
        "Roof waterproofing systems are protective measures applied to roofs to prevent water infiltration and damage. These systems typically involve the application of waterproof membranes, coatings, or sealants to create a barrier against rain, snow, and moisture.",
    },
    {
      linkUrl: "/products/vista-power-silica-fume",
      imageUrl: "/images/dummy-img.jpg",
      cardTitle: "Vista Power Silica Fume",
      cardContent:
        "This method involves the use of cement-based coatings or additives to create a waterproof barrier. It is often used for concrete structures and can be applied to both the positive and negative sides of walls.",
    },
    {
      linkUrl: "/products/vista-seal-it",
      imageUrl: "/images/dummy-img.jpg",
      cardTitle: "Vista Seal IT",
      cardContent:
        "Bituminous coatings, such as asphalt or coal tar, are used for waterproofing flat roofs and foundations. These materials are applied in liquid form and then solidify to create a durable waterproof layer.",
    },
    {
      linkUrl: "/products/vista-superplast-hs",
      imageUrl: "/images/dummy-img.jpg",
      cardTitle: "Vista Superplast HS",
      cardContent:
        "This method involves the use of cement-based coatings or additives to create a waterproof barrier. It is often used for concrete structures and can be applied to both the positive and negative sides of walls.",
    },
    {
      linkUrl: "/products/vista-superplast-hs-1000",
      imageUrl: "/images/dummy-img.jpg",
      cardTitle: "Vista Superplast HS 1000",
      cardContent:
        "Liquid-applied waterproofing membranes are flexible coatings that can be applied directly onto surfaces such as roofs, walls, and foundations. They are often used for their ease of application and ability to conform to irregular shapes.",
    },
    {
      linkUrl: "/products/vista-afa-super",
      imageUrl: "/images/dummy-img.jpg",
      cardTitle: "Vista AFA",
      cardContent:
        "Bituminous coatings, such as asphalt or coal tar, are used for waterproofing flat roofs and foundations. These materials are applied in liquid form and then solidify to create a durable waterproof layer.",
    },
    {
      linkUrl: "/products/vista-shot-x",
      imageUrl: "/images/dummy-img.jpg",
      cardTitle: "Vista Shot X",
      cardContent:
        "Bituminous coatings, such as asphalt or coal tar, are used for waterproofing flat roofs and foundations. These materials are applied in liquid form and then solidify to create a durable waterproof layer.",
    },
    {
      linkUrl: "/products/vista-crystal-plus",
      imageUrl: "/images/dummy-img.jpg",
      cardTitle: "Vista Crystal Plus",
      cardContent:
        "This method involves the use of cement-based coatings or additives to create a waterproof barrier. It is often used for concrete structures and can be applied to both the positive and negative sides of walls.",
    },
  ];